import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AvField from "../../../shared/component/form/AvField";
import {REQUEST_TYPES_CONS, SERVICE_NAME} from "../../../shared/utils/Constants";


const defaultExternalResolutionMapParameter = {
    id: '',
    serviceName: '',
    requestType: '',
    resolutionCode: '',
    extResolutionCode: ''
};

export default class ExternalResolutionMapSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            externalResolutionMapParameter: defaultExternalResolutionMapParameter,
            pageMode: null
        };
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="serviceName">Hizmet Türü<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="serviceName"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 40,
                                    errorMessage: 'Bu alan en fazla 40 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.externalResolutionMapParameter.serviceName}
                            onChange={this.__handleChange}
                        >
                            <option value='' key=''/>
                            {SERVICE_NAME.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>
                            ))}
                        </AvField>
                    </AvGroup>

                    <AvGroup>
                        <Label for="requestType">Talep Tipi<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="requestType"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 40,
                                    errorMessage: 'Bu alan en fazla 40 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.externalResolutionMapParameter.requestType}
                            onChange={this.__handleChange}
                        >
                            <option value='' key=''/>
                            {REQUEST_TYPES_CONS.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>
                            ))}
                        </AvField>
                    </AvGroup>

                    <AvGroup>
                        <Label for="resolutionCode">Çözüm Kodu<span style={{color: 'red'}}> (*)</span></Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="resolutionCode"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 100,
                                    errorMessage: 'Bu alan en fazla 100 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.externalResolutionMapParameter.resolutionCode}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>

                    <AvGroup>
                        <Label for="extResolutionCode">Dış Sistem Çözüm Kodu<span style={{color: 'red'}}> (*)</span></Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="extResolutionCode"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 100,
                                    errorMessage: 'Bu alan en fazla 100 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.externalResolutionMapParameter.extResolutionCode}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let externalResolutionMapParameter = this.state.externalResolutionMapParameter;
        externalResolutionMapParameter[e.target.name] = value;
        this.setState({externalResolutionMapParameter: externalResolutionMapParameter});
    }

    setData = (data, pageMode) => {
        this.setState({externalResolutionMapParameter: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.externalResolutionMapParameter;
    }

    clearData = () => {
        this.setState({
            externalResolutionMapParameter: Object.assign({}, defaultExternalResolutionMapParameter),
            pageMode: null
        });
    }

}
